import React from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";

import MasterFinyearAddForm from "./MasterFinyearAddForm";

const MasterFinyearAdd = ({ buttonConfig, isButtonClicked }) => {
  const schema = z.object({
    fin_year_name: z.string().nonempty(),
    fin_year_short_name: z.string(),
    eff_start_date: z.string().nonempty(),
    eff_end_date: z.string().nullable(),
    status: z.boolean().or(z.string()),
  });

  const form = useForm({
    defaultValues: {
      status: "true",
      fin_year_short_name: "",
      eff_end_date: null,
    },
    resolver: zodResolver(schema),
  });

  return (
    <MasterFinyearAddForm
      form={form}
      segmentName={buttonConfig.name}
      addHandler={buttonConfig.addHandler}
      closeHandler={buttonConfig.closeAddModal}
      isButtonClicked={isButtonClicked}
    />
  );
};

export default MasterFinyearAdd;
